import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import lottieWeb from 'lottie-web'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

const solutionsPin = (el) => {
	if (!el || window.innerWidth < 1000) return

	let animation
	let diagram = el.querySelector('[data-diagram]')
	let labelLinks = el.querySelectorAll('.label')
	let labels = el.querySelectorAll('[data-label]')
	let path = diagram?.getAttribute('data-diagram')

	if (path) {
		animation = lottieWeb.loadAnimation({
			container: diagram,
			autoplay: false,
			renderer: 'canvas',
			loop: false,
			path: path
		})

		animation.goToAndStop(1, true)
	}

	let tl = gsap.timeline({
		anticipatePin: true,
		scrollTrigger: {
			trigger: el,
			start: 'center center',
			end: '+=5000',
			pin: true,
			scrub: true,
			onUpdate: (self) => {
				const currentIteration = Math.floor(tl.progress() * labels.length)

				if (currentIteration < labels.length) el.setAttribute('data-current', currentIteration + 1)

				if (path) animation.goToAndStop(tl.progress() * animation.totalFrames, true)
			}
		}
	})

	labels.forEach((label, i) => {
		tl.fromTo(
			label,
			{
				clipPath: 'polygon(0 -15%, 0 -15%, 0 115%, 0 115%)'
			},
			{
				duration: 1,
				clipPath: 'polygon(0 -15%, 100% -15%, 100% 115%, 0 115%)'
			}
		)
		tl.addLabel(`label-${i}`)
	})

	labelLinks.forEach((label, i) => {
		label.addEventListener('click', () => {
			gsap.to(window, { scrollTo: tl.scrollTrigger.labelToScroll(`label-${i}`) - 150 })
		})
	})
}

export const initSolutionsPin  = () => {
	const els = document.querySelectorAll('[data-solutions-pin]')

	if (!els.length) return
  
  els.forEach(el => {
    ScrollTrigger.create({
      trigger: el,
      start: 'top bottom',
      once: true,
      onEnter: () => solutionsPin(el)
    })
  })
}

export default () => {}
